export default "assets/images/icons/account-8f37af73.svg";